import store from "../store";
import Vue from "vue";
import SingleSelectedDecorator from "./singleSelectedDecorator";

export default class SelectedStoreBase {
  private static getters() {
    return {
      getSingle(state): Function {
        return (key: string) => {
          return state[key];
        };
      }
    };
  }

  private static mutations() {
    return {
      setSingle(state, { key, item }: { key: string, item: any }): void {
        Vue.set(state, key, item);
      }
    };
  }

  static register(type: new () => any): void {
    if (!store.state['selected']) { // avoid registering twice
      store.registerModule('selected', this.module(type));
    }
  }

  static module(type: new () => any): {} {
    const modules = [];
    modules.push({
      namespaced: true,
      getters: this.getters(),
      mutations: this.mutations(),
    });
    for (const key in type) {
      const prop = type[key];
      if (prop instanceof SingleSelectedDecorator) {
        modules.push({state: (<SingleSelectedDecorator<any>>prop).state()});
      }
    }
    const module = window.AppConfig.mergeJson(...modules);
    return module;
  }
}